import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from 'components/typography/Text';
import { Image as SemanticImage } from 'semantic-ui-react';
import mailAndParcelsSrc from 'assets/media/eden/my-workspace/mail-and-parcels.jpeg';
import styles from '../styles.module.scss';

export const MailAndParcels = () => (
  <>
    <SemanticImage
      src={mailAndParcelsSrc}
      alt="Mail & parcels"
      className={styles.image}
    />

    <Text size={16}>
      <FormattedMessage
        id="mailAndParcelsDescription"
        values={{
          bold: (...chunks) => (
            <Text
              size={16}
              element="span"
              bold
            >
              {chunks}
            </Text>
          ),
        }}
      />
    </Text>
  </>
);
